import React from 'react';
import { IconWarning } from '@americanexpress/dls-icons';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Surface } from '@americanexpress/dls-react';
import { getWarnings } from '../../selectors/validationSelectors';

const ErrorsWarning = () => {
  const warnings = useSelector(getWarnings);
  const hasWarnings = warnings.length > 0;
  const { formatMessage } = useIntl();

  if (!hasWarnings) {
    return null;
  }

  return (
    <Surface variant="foreground">
      <div
        id="packagesErrorMessageBlock"
        className="card-block color-status-text-critical pad-1-tb pad-3-l flex flex-wrap border-b"
        role="alert"
      >
        <IconWarning
          color="critical"
          size="md"
          isFilled={false}
        />
        <div className="pad-1-l">
          <FormattedMessage id="validation.please_correct_the_following" />
          <ul>
            {
              warnings
                .map((warning) => (
                  <li key={typeof warning === 'string' ? warning : warning.key}>
                    {typeof warning === 'string'
                      ? formatMessage({
                        id: `validation.${warning}`,
                      })
                      : formatMessage({
                        id: `validation.${warning.key}`,
                      }, {
                        value: warning.value,
                      })}
                  </li>
                ))
            }
          </ul>
        </div>
      </div>
    </Surface>
  );
};

export default ErrorsWarning;
